<div class="flip-population-container">
  <div class="content-wrapper">
    <!-- Chart Section -->
    <div class="chart-section">
      <div class="chart-container">
        <canvas #populationChart></canvas>
        <div *ngIf="!dataLoaded" class="loading-message">Loading data...</div>
        <div
          *ngIf="
            dataLoaded &&
            (!rawData ||
              !rawData.flipPopulationCounts ||
              rawData.flipPopulationCounts.length === 0)
          "
          class="no-data-message"
        >
          No population data available
        </div>
      </div>
    </div>

    <!-- Filters and Table Section -->
    <div class="filters-table-section">
      <!-- Filters -->
      <div class="filters-container">
        <div class="filter-row">
          <app-dropdown
            label="{{ 'Case Manager' | translate }}"
            [data]="caseManagerOptions"
            [control]="caseManagerFilterControl"
            [id]="'caseManagerFilter'"
          ></app-dropdown>
        </div>
        <div class="filter-row">
          <app-dropdown
            label="{{ 'Client' | translate }}"
            [data]="clientOptions"
            [control]="clientFilterControl"
            [id]="'clientFilter'"
          ></app-dropdown>
        </div>
        <div class="filter-row" *ngIf="selectedAgeRange || selectedScoreFilter">
          <button mat-raised-button color="primary" (click)="clearSelection()">
            {{
              (selectedScoreFilter
                ? 'Clear Score Selection'
                : 'Clear Age Selection'
              ) | translate
            }}
          </button>
        </div>
      </div>

      <!-- Client List Table -->
      <div class="table-container">
        <table mat-table [dataSource]="filteredClients" class="client-table">
          <!-- Client Name Column -->
          <ng-container matColumnDef="clientName">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'Client' | translate }}
            </th>
            <td mat-cell *matCellDef="let client">{{ client.clientName }}</td>
          </ng-container>

          <!-- Age Column -->
          <ng-container matColumnDef="age">
            <th mat-header-cell *matHeaderCellDef>{{ 'Age' | translate }}</th>
            <td mat-cell *matCellDef="let client">{{ client.age }}</td>
          </ng-container>

          <!-- Date of Birth Column -->
          <ng-container matColumnDef="dateOfBirth">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'Date of Birth' | translate }}
            </th>
            <td mat-cell *matCellDef="let client">
              {{ formatDateOfBirth(client.dateOfBirth) }}
            </td>
          </ng-container>

          <!-- Case Manager Column -->
          <ng-container matColumnDef="caseManagerName">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'Case Manager' | translate }}
            </th>
            <td mat-cell *matCellDef="let client">
              {{ client.caseManagerName }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>

        <div *ngIf="filteredClients.length === 0" class="no-data">
          No clients match the selected filters
        </div>
      </div>
    </div>
  </div>
</div>
